import React from 'react';
import styles from './css/index.module.scss';
import SearchIcon from '../../../../assets/icons/search.svg';
import ErrorIcon from '../../../../assets/icons/error.svg';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';

export const RESULTS_STATES = {
  empty: 'empty',
  error: 'error',
};

const CONTENT = {
  [RESULTS_STATES.empty]: {
    icon: SearchIcon,
    title: DICTIONARY.soundproofingPage.noResultsTitle,
    text: DICTIONARY.soundproofingPage.noResultsText,
  },
  [RESULTS_STATES.error]: {
    icon: ErrorIcon,
    title: DICTIONARY.soundproofingPage.errorTitle,
    text: DICTIONARY.soundproofingPage.errorText,
  },
};

function ResultsState({ type }) {
  const { t } = useTranslations();
  const { icon, title, text } = CONTENT[type];

  return (
    <div className={styles.state}>
      <img src={icon} alt="" className={styles.icon} />
      <p className={styles.title}>{t(title)}</p>
      <p className={styles.text}>{t(text)}</p>
    </div>
  );
}

export default ResultsState;
